let fullBlocked = false;

export function block() {
    const div = document.createElement('div');
    div.setAttribute('id', 'fullBlock');

    if (!fullBlocked) {
        div.innerHTML = '<div class="gear_animated"></div>';

        $('#fullBlock').show();
        $('body').addClass('full-blocked');
        fullBlocked = true;

        return document.body.appendChild(div);
    }

    return false;
}

export function unblock() {
    $('#fullBlock').remove();
    $('body').removeClass('full-blocked');
    fullBlocked = false;

    return false;
}
